
import "./HoverTitle.css"; // برای استایل اضافه

const HoverTitle = ({ title, imageUrl,image }) => {
  return (
    <div className="hover-title-wrapper position-relative d-inline-block">
      <span className="hover-title-text fs-6">{title}</span>
      <div className="hover-tooltip-img shadow rounded">
        <img className="img-thumbnail" src={imageUrl} alt={title} />
      </div>
    </div>
  );
};

export default HoverTitle;
